
    import './styles.scoped.css';
    export default {
  "drawer": "awsui_drawer_12i0j_1uef0_189",
  "with-expanded-motion": "awsui_with-expanded-motion_12i0j_1uef0_203",
  "legacy": "awsui_legacy_12i0j_1uef0_217",
  "last-opened": "awsui_last-opened_12i0j_1uef0_225",
  "drawer-global": "awsui_drawer-global_12i0j_1uef0_229",
  "drawer-expanded": "awsui_drawer-expanded_12i0j_1uef0_238",
  "drawer-hidden": "awsui_drawer-hidden_12i0j_1uef0_242",
  "has-next-siblings": "awsui_has-next-siblings_12i0j_1uef0_252",
  "global-drawer-wrapper": "awsui_global-drawer-wrapper_12i0j_1uef0_252",
  "drawer-content-container": "awsui_drawer-content-container_12i0j_1uef0_266",
  "drawer-gap": "awsui_drawer-gap_12i0j_1uef0_269",
  "drawer-close-button": "awsui_drawer-close-button_12i0j_1uef0_287",
  "drawer-expanded-mode-button": "awsui_drawer-expanded-mode-button_12i0j_1uef0_293",
  "drawer-content": "awsui_drawer-content_12i0j_1uef0_266",
  "drawer-content-hidden": "awsui_drawer-content-hidden_12i0j_1uef0_305",
  "drawer-slider": "awsui_drawer-slider_12i0j_1uef0_308",
  "drawer-actions": "awsui_drawer-actions_12i0j_1uef0_359"
};
  